import { useAppSelector } from 'store/hooks';

export const useLocalization = () => {
  const { localization, currentLanguage } = useAppSelector((state) => state.global);
  const translate = (key: string) => {
    const keyPrefix = `cryptoPay.${key}`;
    if (localization[currentLanguage] && localization[currentLanguage][keyPrefix]) {
      return localization[currentLanguage][keyPrefix];
    }

    return keyPrefix;
  };

  const translateServerError = (code: string, message: string) => {
    const key = `Server.Error.${code}`;
    const translated = translate(key);
    return translated === `cryptoPay.${key}` ? message : translated;
  };

  return {
    currentLanguage,
    translate,
    translateServerError,
  };
};

export default useLocalization;
